import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/tooltip';

import './styles.scss';

export default function ContactTooltip({ contactRoles, deal }) {
  const firstRole = contactRoles[0];
  let value = getContactLabel(firstRole, deal);
  if (contactRoles.length > 1) {
    value = `${value} & ${contactRoles.length - 1} more`;
  }

  const buildTooltipContent = () => {
    return (
      <table>
        <tbody>
          {contactRoles.map(role => (
            <tr key={role.id}>
              <td>
                <label className="label sm pill-label contact-type-label">
                  {role.roleLabel}
                </label>
              </td>
              <td>
                {getContactLabel(role, deal)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <Tooltip
      content={buildTooltipContent()}
      overlayClassName="backoffice-contacts-tooltip"
      placement="bottom"
    >
      <a href={deal && `${deal.path}/contacts`}>{value}</a>
    </Tooltip>
  );
}

ContactTooltip.propTypes = {
  contactRoles: PropTypes.arrayOf(PropTypes.shape({
    contactName: PropTypes.string,
    contact: PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string,
    }),
  })).isRequired,
  deal: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

function getContactLabel(contactRole, deal) {
  // TODO: Serialize things consistently instead of switching on the presence of a deal
  return deal ? (contactRole.contact.name || contactRole.contact.email) : contactRole.contactName;
}
